import { Box, IconButton, Tooltip } from "@mui/material";
import { HoverImage, LabelColumnV2, } from "../../components/DataGridV2/DataColumnsV2";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { formatDate } from "../../_helpers";
import { Cancel, Image } from "@mui/icons-material";

export const getBuyerRepairRequestResolverColumns = ({
  t,
  keyPrefix,
  i18n,
  apiRef,
  classes,
  theme,
  handleAppointmentCancelDialogOpen
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.BUYER_REPAIR_REQUEST_RESOLVERS_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
    getValueForCopy: (rowData, extraData) => {
      let text = ""
      switch (extraData.fieldName) {
        case "dateNotified":
          text = rowData.dateNotified ? formatDate(new Date(rowData?.dateNotified)) : ""
          break;
        case "appointmentDateTime":
          text = rowData?.appointmentDateTime ? formatDate(new Date(rowData?.appointmentDateTime), true) : ""
          break;
        default:
          text = rowData[extraData.fieldName]
          break;
      }
      return text
    },
  })
  return [
    {
      download: false,
      print: true,
      field: "organisatonId",
      headerName: t("general.image"),
      editable: false,
      disableColumnMenu: true,
      flex: 1,
      align: "center",
      filterable: false,
      minWidth: 45,
      maxWidth: 45,
      forceApplyWidth: true,
      sortable: false,
      renderCell: (params) => {
        const imageId = params?.row?.organisatonId;
        return (
          <HoverImage defaultSize={20} imageId={imageId} index={params.id} />
        );
      },
      renderHeader: () => {
        return (
          (<Box component="div" sx={{
            textAlign: "center"
          }}>
            <Image />
          </Box>)
        );
      },
    },
    {
      download: true,
      print: true,
      field: "name",
      headerName: t("general.organisation"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.name}
            cellSubMenuOptions={{ options: getOptions({ field: "name", isQuickFilterDisplay: Boolean(rowData.name) }), extraData: { fieldName: "name" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "telephone",
      headerName: t("repairRequest.phoneNumber"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={rowData.telephone}
            cellSubMenuOptions={{ options: getOptions({ field: "telephone", isQuickFilterDisplay: Boolean(rowData.telephone) }), extraData: { fieldName: "telephone" } }}
            request={rowData}
          />
        );
      },
    },
    {
      field: "dateNotified",
      headerName: t('repairRequest.notifiedOn'),
      flex: 1,
      minWidth: 90,
      type: "date",
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      download: true,
      renderCell: (params) => {
        const rowData = params.row;
        return <LabelColumnV2 date={rowData.dateNotified}
          cellSubMenuOptions={{ options: getOptions({ field: "dateNotified", isQuickFilterDisplay: rowData?.dateNotified }), extraData: { fieldName: "dateNotified", type: "date" } }}
          request={rowData}
        />
      },
    },
    {
      download: true,
      print: true,
      field: "appointmentDateTime",
      headerName: t("general.appointment"),
      flex: 1,
      align: 'center',
      minWidth: 90,
      type: 'dateTime',
      valueGetter: (params) => {
        if (!params) return "";
        return new Date(params);
      },
      renderCell: (params) => {
        const rowData = params.row;
        if (!rowData) return "";
        const appointmentDateTime = rowData?.appointmentDateTime
          ? formatDate(new Date(rowData?.appointmentDateTime), true)
          : null;
        return (
          <LabelColumnV2
            spanClass={rowData?.appointmentCancelled && classes.lineThrough}
            label={appointmentDateTime}
            color={rowData?.appointmentCancelled && theme.palette.error.dark}
            cellSubMenuOptions={{ options: getOptions({ field: "appointmentDateTime", isQuickFilterDisplay: Boolean(appointmentDateTime), }), extraData: { fieldName: "appointmentDateTime", type: "dateTime" }, }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "",
      flex: 1,
      sortable:false,
      filterable:false,
      align: "start",
      minWidth: 90,
      renderCell: (params) => {
        const resolver = params.row;
        const request = params.row;
        if (!request) return "";
        if (!resolver.appointmentCancelled && resolver.appointmentDateTime) {
          return (
            <LabelColumnV2
              label={
                <IconButton size="small" onClick={() => handleAppointmentCancelDialogOpen(resolver)}>
                  <Tooltip title={t("general.cancel")} arrow enterTouchDelay={0}>
                    <Cancel />
                  </Tooltip>
                </IconButton>
              }
            />
          );
        }
        return "";
      },
    }

  ];
}